import React from 'react';
import injectStore from '../util/injectStore';
import cn from 'classnames';

export default injectStore(({ lite = false, margin = false }) => (
  <hr className={`divider ${cn({ lite, margin })}`} />
));
